import { Plus, Trash2 } from 'lucide-react';
import { Button, Input } from '@vnetwork/ui/primitives';
import type { ClusterTag } from './cluster-draft';

/** Key/value labels for the cluster, capped at 50 (mirrors the legacy Tags section). */
export function TagsStep({ tags, onChange }: { tags: ClusterTag[]; onChange: (tags: ClusterTag[]) => void }) {
  const set = (i: number, patch: Partial<ClusterTag>) => onChange(tags.map((t, j) => (j === i ? { ...t, ...patch } : t)));
  return (
    <div style={{ display: 'grid', gap: 'var(--vn-space-2)', maxWidth: 560 }}>
      {tags.map((t, i) => (
        <div key={i} style={{ display: 'flex', gap: 'var(--vn-space-2)', alignItems: 'center' }}>
          <Input value={t.key} placeholder="key" onChange={(e) => set(i, { key: e.target.value })} style={{ width: 200 }} />
          <Input value={t.value} placeholder="value" onChange={(e) => set(i, { value: e.target.value })} style={{ width: 240 }} />
          <Button type="button" variant="ghost" size="sm" onClick={() => onChange(tags.filter((_, j) => j !== i))}><Trash2 size={15} /></Button>
        </div>
      ))}
      <div>
        <Button type="button" variant="secondary" size="sm" startIcon={<Plus size={14} />} disabled={tags.length >= 50} onClick={() => onChange([...tags, { key: '', value: '' }])}>
          Add new tag
        </Button>
      </div>
      <p style={{ margin: 0, color: 'var(--vn-fg-muted)', fontSize: 'var(--vn-font-size-sm)' }}>
        You can add up to {Math.max(0, 50 - tags.length)} more tags.
      </p>
    </div>
  );
}
